import { TableRow } from '@mui/material'
import { HeaderGroup, Header as THeader } from '@tanstack/react-table'

import { Header } from './Header'
import { HeaderGroupsProps } from './types'

export const HeaderGroups = <T,>({
  headerGroups,
  ...props
}: HeaderGroupsProps<T>): React.JSX.Element => (
  <>
    {headerGroups.map(
      (headerGroup: HeaderGroup<T>): React.JSX.Element => (
        <TableRow key={headerGroup.id}>
          {headerGroup.headers
            .filter((header: THeader<T, unknown>): boolean =>
              Boolean(!header.column.columnDef.meta?.hidden),
            )
            .map(
              (header: THeader<T, unknown>): React.JSX.Element => (
                <Header
                  header={header}
                  key={header.id}
                  {...props}
                />
              ),
            )}
        </TableRow>
      ),
    )}
  </>
)
